
export const PortalBaseUrl = {

    /**
     * Custom portal URL set by user using dev menu has the highest priority
     */
    get() {
        return window.PORTAL_BASE_URL || '/portal.proxy/' + ($util.cookie('CP_API') || window.env) + '/portal';
    }
}


window.baseUrl = PortalBaseUrl;
